
import { motion } from 'framer-motion';
import { galleryCategories } from '../../../mocks/galleryProjects';

interface GalleryFilterProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function GalleryFilter({
  activeCategory,
  onCategoryChange,
}: GalleryFilterProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8 sm:mb-12 lg:mb-16 px-1"
    >
      {galleryCategories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-3 sm:px-6 py-2 sm:py-3 text-[9px] sm:text-sm font-semibold tracking-wider uppercase transition-all duration-400 cursor-pointer whitespace-nowrap border ${
            activeCategory === category
              ? 'bg-[#00E5FF] text-[#050505] border-[#00E5FF] shadow-[0_0_20px_rgba(0,229,255,0.3)]'
              : 'bg-transparent text-[#C0C7CF] border-[#C0C7CF]/20 hover:border-[#00E5FF]/60 hover:text-[#00E5FF]'
          }`}
          style={{ fontFamily: 'Orbitron, sans-serif' }}
        >
          {category}
        </button>
      ))}
    </motion.div>
  );
}
